export default __webpack_public_path__ + "static/media/processingTransaction.cbd27c39.svg";